import { useEffect } from "react";
import Header from "../components/Header";

export default function Testimonials() {
  useEffect(() => {
    if (!window.FB) {
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v17.0";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    } else {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <div className="font-serif">
      <Header />
      <section className="w-full bg-white py-16 px-6 text-center">
        <h2 className="text-4xl font-bold text-green-900 mb-4">
          What Our Clients Say
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-10">
          We are proud to have helped make so many moments memorable. Read what our happy clients have to say!
        </p>

        <div className="flex justify-center">
          <div
            className="fb-page"
            data-href="https://www.facebook.com/sarithaGajjala03/reviews"
            data-tabs="reviews"
            data-width="500"
            data-height="600"
            data-small-header="false"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="true"
          />
        </div>
      </section>
    </div>
  );
}
